import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseVolume } from './base';

/**
 * @internal
 */
export class ApiVolume extends ApiBaseVolume {
  @ApiOptions({ channel: 'volumeGasCapacity' })
  getGasCapacity(gridOperator: string, meteringPoint: string, capacityLevel: string, params: ParamsAdapter) {
    return this.get(`/volume/gas/${gridOperator}/${meteringPoint}/capacity/${capacityLevel}/view`, params);
  }

  @ApiOptions({ channel: 'volumeGasCapacityLevel' })
  getGasCapacityLevel(gridOperator: string, meteringPoint: string, capacityLevel: string, params: ParamsAdapter) {
    return this.get(`/volume/gas/${gridOperator}/${meteringPoint}/capacity/${capacityLevel}`, params);
  }

  @ApiOptions({ channel: 'volumeExportExcel', responseType: 'blob' })
  getExcelSync(commodity: string, params: ParamsAdapter) {
    return this.get<Blob>(`/volume/${commodity}/export-excel`, params);
  }

  @ApiOptions({ channel: 'volumeGasCapacityLevelPost' })
  postGasCapacityLevel(gridOperator: string, meteringPoint: string, capacityLevel: string, params: ParamsAdapter) {
    return this.post(`/volume/gas/${gridOperator}/${meteringPoint}/capacity/${capacityLevel}`, params);
  }
}
